
//动态列自定义表格
export default {
  data() {
    return {
      columnData: [],
      tableDataSet: [],
      reportName: 'DYN_MERCHANDISE_SALE_QUERY',
      tableVisible: false,
      pagingColumnData: [],
      isShowTure: [],
      userColumnsData: [],
      tableReload: true
    }
  },
  mounted() {
    this.columns()
  },
  methods: {
    columns() {
      this.$q.goods.columns({ params: { reportName: this.reportName } }).then(res => {
        this.isShowTure = res.data.userColumns.length ? res.data.userColumns.filter(v=>v.isShow).map(v=>v.displayName) : []
        this.userColumnsData = res.data.userColumns.length ? res.data.userColumns : []
        this.customColumn()
        // }
      });
    },
    closeAddForm() {
      this.tableVisible = false;
      this.columns()
    },
    confirm() {
      let data = []
      this.tableDataSet.forEach(v => {
        let freezeFlag = v.freezeLeft || v.freezeRight ? true : false
        data.push({
          displayName: v.displayName,
          columnName: v.columnName,
          displayWidth: parseInt(v.displayWidth),
          reportName: this.reportName,
          freezeFlag: freezeFlag,
          freezeType: freezeFlag && v.freezeLeft ? 'left' : freezeFlag && v.freezeRight ? 'right' : '',
          isShow: v.isShow
        })
      })
      this.$q.common.mergeColumns({ data: data }).then(res => {
        if (res.success) {
          this.$message.success('自定义配置成功')
          this.tableReload = false
          this.$nextTick(_ => {
            this.tableReload = true;
          });
          this.columns()
        } else {
          this.$message.error('自定义配置失败')
        }
        this.closeAddForm()
      });
    },
     customColumn(data) {
      this.columnData = []
      var data = [];
      var tableDataSet = []
      //当前页面存在重复的列名 不在使用列名去判断  使用列的字段名去判断
      var columnData = this.userColumnsData.map(v=>v.columnName) 
      this.pagingColumnData.forEach((v) => {
        let index = columnData.indexOf(v.propertyName)
        if(this.userColumnsData.length) { //用户配置返回
          if(columnData.indexOf(v.propertyName) != -1) { //包含用户之前配置的列
            tableDataSet.push({
              displayName: this.userColumnsData[index].displayName,
              displayWidth: this.userColumnsData[index].displayWidthNum ? parseInt(this.userColumnsData[index].displayWidthNum) : 100,
              freezeLeft: this.userColumnsData[index].freezeType == 'left' ? true : false,
              freezeRight: this.userColumnsData[index].freezeType == 'right' ? true : false,
              isShow: this.userColumnsData[index].isShow,
              columnName: this.userColumnsData[index].columnName
            })
            if(this.isShowTure.indexOf(v.titleName) == -1) {
              data.push({
                label: this.userColumnsData[index].displayName,
                prop: this.userColumnsData[index].columnName,
                width: this.userColumnsData[index].displayWidth,
                sortable: v.sortable == "1" ? 'custom' : false,
                span: false,
                fixed: this.userColumnsData[index].freezeType,
              });
            }
          }else { //不包含使用分页返回的列
            tableDataSet.push({
              displayName: v.titleName,
              displayWidth: v.displayWidth ? parseInt(v.displayWidth) : '100',
              freezeLeft: v.freezeType == 'left' ? true : false,
              freezeRight: v.freezeType == 'right' ? true : false,
              isShow: v.isShow,
              columnName: v.propertyName
            })
            if(this.isShowTure.indexOf(v.titleName) == -1) {
              data.push({
                label: v.titleName,
                prop: v.propertyName,
                width: v.displayWidth || '100px',
                sortable: v.sortable == '1' ? "custom" : false,
                span: false,
                fixed: v.fixed == "1" ? "left" : false,
              });
            }
          }
        }else {//用户为配置使用分页默认配置
          tableDataSet.push({
            displayName: v.titleName,
            displayWidth: v.displayWidth ? parseInt(v.displayWidth) : '100',
            freezeLeft: v.fixed == '1' ? true : false,
            freezeRight: false,
            isShow: v.isShow,
            columnName: v.propertyName
          })
          data.push({
            label: v.titleName,
            prop: v.propertyName,
            width: v.displayWidth || '100px',
            sortable: v.sortable == '1' ? "custom" : false,
            span: false,
            fixed: v.fixed == "1" ? "left" : false,
           });
          }
      });
      this.columnData = data
      this.tableDataSet = tableDataSet
    }
  }
}